import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import Empresa from "@/pages/Empresa";
import Catalog from "@/pages/Catalog";
import CategoryPage from "@/pages/CategoryPage";
import ProductDetail from "@/pages/ProductDetail";
import Applications from "@/pages/Applications";
import ApplicationDetail from "@/pages/ApplicationDetail";
import Dimensionamento from "@/pages/Dimensionamento";
import Assistencia from "@/pages/Assistencia";
import Pecas from "@/pages/Pecas";
import Conteudos from "@/pages/Conteudos";
import ArticleDetail from "@/pages/ArticleDetail";
import Catalogos from "@/pages/Catalogos";
import Contato from "@/pages/Contato";
import NotFound from "@/pages/NotFound";
import ProjetosEspeciais from "@/pages/ProjetosEspeciais";
import EquipmentLookup from "@/pages/EquipmentLookup";

import Login from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import LeadsAdmin from "@/pages/admin/LeadsAdmin";
import ProductsAdmin from "@/pages/admin/ProductsAdmin";
import CategoriesAdmin from "@/pages/admin/CategoriesAdmin";
import ConfigAdmin from "@/pages/admin/ConfigAdmin";
import ShowcaseAdmin from "@/pages/admin/ShowcaseAdmin";
import EquipmentAdmin from "@/pages/admin/EquipmentAdmin";

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <AuthProvider>
          <SiteProvider>
            <Toaster position="top-right" theme="dark" richColors />
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/empresa" element={<Empresa />} />
                <Route path="/equipamentos" element={<Catalog />} />
                <Route path="/equipamentos/:slug" element={<CategoryPage />} />
                <Route path="/produto/:slug" element={<ProductDetail />} />
                <Route path="/solucoes" element={<Applications />} />
                <Route path="/solucoes/:slug" element={<ApplicationDetail />} />
                <Route path="/dimensionamento" element={<Dimensionamento />} />
                <Route path="/assistencia" element={<Assistencia />} />
                <Route path="/pecas" element={<Pecas />} />
                <Route path="/conteudos" element={<Conteudos />} />
                <Route path="/conteudos/:slug" element={<ArticleDetail />} />
                <Route path="/catalogos" element={<Catalogos />} />
                <Route path="/projetos-especiais" element={<ProjetosEspeciais />} />
                <Route path="/pos-venda" element={<EquipmentLookup />} />
                <Route path="/equipamento/:serial" element={<EquipmentLookup />} />
                <Route path="/contato" element={<Contato />} />
                <Route path="*" element={<NotFound />} />
              </Route>

              <Route path="/admin/login" element={<Login />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="leads" element={<LeadsAdmin />} />
                <Route path="produtos" element={<ProductsAdmin />} />
                <Route path="categorias" element={<CategoriesAdmin />} />
                <Route path="prova-social" element={<ShowcaseAdmin />} />
                <Route path="pos-venda" element={<EquipmentAdmin />} />
                <Route path="config" element={<ConfigAdmin />} />
              </Route>
            </Routes>
          </SiteProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
